import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDriverBlockEntity } from '../../domain/entities/CreateUpdateDriverBlockEntity'
import moment from 'moment'

export class CreateUpdateDriverBlockModel extends CreateUpdateDriverBlockEntity {
  blockedAt?: string
  unblockedAt?: string | null
  driverId = 0
  constructor(dataDto: CreateUpdateDriverBlockEntity) {
    super()
    mapEntityProperties<CreateUpdateDriverBlockModel>(this, dataDto, {
      exclude: ['blockedDate', 'unblockedDate'],
      map: {
        blockedAt: dataDto.blockedDate ? moment.utc(dataDto.blockedDate).format('') : undefined,
        unblockedAt: dataDto.unblockedDate
          ? moment.utc(dataDto.unblockedDate).format('')
          : undefined
      }
    })
  }
}
